import { Injectable } from '@angular/core';

import { doc, docData, collection, collectionData, Firestore, query, orderBy, where, addDoc, updateDoc, deleteDoc, setDoc, deleteField } from '@angular/fire/firestore';

import { map } from 'rxjs/operators';

import { Character } from '../classes/index';

@Injectable()
export class CharacterService {

	constructor(private firestore: Firestore) {
	}

	listCharacters(collectionPath) {
		return collectionData(query(collection(this.firestore, collectionPath)), { idField: 'id' })
		.pipe(map(collection => {
			return collection.map(data => {
				let item = new Character(collectionPath);
				item.fromJSON(data);
				return item;
			});
		}))
		.pipe(map(characters => characters.sort((a, b) => {
			if (a.labels['fr'] > b.labels['fr']) return 1;
			else if (a.labels['fr'] < b.labels['fr']) return -1;
			else return 0;
		})));
	}

	getCharacters(collectionPath){
		return collectionData(query(collection(this.firestore, collectionPath)), { idField: 'id' })
		.pipe(map(collection => {
			return collection.map(data => {
				let item = new Character(collectionPath);
				item.fromJSON(data);
				return item;
			});
		}));
	}

	addCharacter(character) {
		let data = { ...character };
		delete data.collectionPath;
		return addDoc(collection(this.firestore, character.collectionPath), {...data});
	}

	setCharacter(character) {
		let data = { ...character };
		delete data.collectionPath;
		return setDoc(doc(this.firestore, character.collectionPath, character.id), data);
	}

	/*async updateAllRole(templateObjects){
		var batch = this.afs.firestore.batch();
		for(let j = 0; j < templateObjects.length; j++){
			let objectsGames = templateObjects[j].changes
			for(let i = 0; i < objectsGames.length; i++){
				templateObjects[j].collectionPath = firebase.firestore.FieldValue.delete();
				batch.update(this.afs.collection(objectsGames[i].collectionPath).doc(`${objectsGames[i].id}`).ref,
					{labels:templateObjects[j].labels, description:templateObjects[j].description, pictureLastUpdate: templateObjects[j].pictureLastUpdate})				
			}
		}
		await batch.commit();	
	}*/

	updateCharacter(character, data){
		data.collectionPath = deleteField();
		return updateDoc(doc(this.firestore, character.collectionPath, character.id), data);
	}

	deleteCharacter(character) {
		return deleteDoc(doc(this.firestore, character.collectionPath, character.id));
	}
}

